import { type PropsWithChildren, type ReactNode } from "react";
import { DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

interface ExamDialogContentProps extends PropsWithChildren {
  bodyClassName?: string;
  className?: string;
  footer?: ReactNode;
  title: ReactNode;
}

export function ExamDialogContent({
  bodyClassName,
  children,
  className,
  footer,
  title,
}: ExamDialogContentProps) {
  return (
    <DialogContent
      className={cn(
        "w-[560px] max-w-[calc(100vw-32px)] flex-col gap-0 overflow-hidden border-0 bg-white p-0 shadow-[0px_2px_4px_rgba(0,0,0,0.04),0px_8px_16px_rgba(0,0,0,0.08)] [display:flex] sm:rounded-[28px] [&>button]:right-6 [&>button]:top-6 [&>button]:flex [&>button]:h-8 [&>button]:w-8 [&>button]:items-center [&>button]:justify-center [&>button]:rounded-md [&>button]:text-[#0a0c11] [&>button]:opacity-100 [&>button]:hover:bg-[#f4f4f6] [&>button_svg]:h-4 [&>button_svg]:w-4",
        className,
      )}
    >
      <DialogHeader className="shrink-0 px-6 pb-4 pt-6 pr-14 text-left">
        <DialogTitle className="text-lg font-semibold leading-7 tracking-normal text-[#0a0c11]">
          {title}
        </DialogTitle>
      </DialogHeader>
      <div className={cn("min-h-0 overflow-y-auto px-6 pb-6", bodyClassName)}>{children}</div>
      {footer && (
        <div className="flex shrink-0 items-center justify-end gap-3 px-6 pb-6">
          {footer}
        </div>
      )}
    </DialogContent>
  );
}
